export default __webpack_public_path__ + "static/media/icon-savings-pig.644efb3c.svg";